<ng-container *ngIf="shoppingCart$ | async as shoppingCart">
  <form [formGroup]="promoForm" (ngSubmit)="onClaimPromoCode()">
    <vnm-form-field label="cart-items.promo-code">
      <vnm-form-actions [showCancel]="false" direction="rtl" submitLabel="claim-promo-code.apply">
        <input pInputText type="search" formControlName="promoCode" vnmPlaceholder="claim-promo-code.placeholder" />
      </vnm-form-actions>
    </vnm-form-field>
  </form>
</ng-container>
